export const mimeTypeMap = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    svg: 'image/svg+xml',
    gif: 'image/gif',
    webp: 'image/webp',
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    txt: 'text/plain',
    csv: 'text/csv',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    pfx: 'application/x-pkcs12',
    p12: 'application/x-pkcs12',
    xml: 'application/xml',
};
export const getDefaultAcceptTypes = (type) => {
    return type === 'image' ? ['jpg', 'png'] : ['pdf', 'doc', 'docx', 'txt'];
};
